import type { ReactNode } from 'react'

export function AuthCard({ title, subtitle, children }: { title: string; subtitle?: string; children: ReactNode }) {
	return (
		<div className="auth-page">
			<div className="card auth-card">
				<div className="brand" style={{ marginBottom: '1rem' }}>
					<span className="brand-mark" aria-hidden />
					StoreKeeper
				</div>
				<h1>{title}</h1>
				{subtitle && <p className="muted small">{subtitle}</p>}
				{children}
			</div>
		</div>
	)
}
